export function preloadAsset(url: string, type: string = 'script') {
  const preloadLink = document.createElement('link');
  preloadLink.href = url;
  preloadLink.rel = 'preload';
  preloadLink.as = type;
  document.getElementsByTagName('head')[0].appendChild(preloadLink);
}

export function preloadImage(url: string) {
  new Image().src = url;
}
